import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=0f462f0a&scoped=true&lang=pug&"
var script = {}
import style0 from "./SortButton.vue?vue&type=style&index=0&id=0f462f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f462f0a",
  null
  
)

export default component.exports